import api from './api';

class LoanService {
  async getAllLoans(params = {}) {
    const response = await api.get('/loans', { params });
    return response.data;
  }

  async getLoan(id) {
    const response = await api.get(`/loans/${id}`);
    return response.data;
  }

  async createLoan(loanData) {
    const response = await api.post('/loans', loanData);
    return response.data;
  }

  async updateLoan(id, loanData) {
    const response = await api.put(`/loans/${id}`, loanData);
    return response.data;
  }

  async approveLoan(id, approvalData) {
    const response = await api.post(`/loans/${id}/approve`, approvalData);
    return response.data;
  }

  async disburseLoan(id, disbursementData) {
    const response = await api.post(`/loans/${id}/disburse`, disbursementData);
    return response.data;
  }

  async getLoanSchedule(id) {
    const response = await api.get(`/loans/${id}/schedule`);
    return response.data;
  }

  async getLoanStatistics() {
    const response = await api.get('/loans/statistics');
    return response.data;
  }

  async getOverdueLoans() {
    const response = await api.get('/loans/overdue');
    return response.data;
  }
}

export default new LoanService();